import { render, staticRenderFns } from "./board_mainbanner_regi.vue?vue&type=template&id=1e7e3c04&"
import script from "./board_mainbanner_regi.vue?vue&type=script&lang=js&"
export * from "./board_mainbanner_regi.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports